import { render } from "./Slips.vue?vue&type=template&id=4becf744"
import script from "./Slips.vue?vue&type=script&lang=js"
export * from "./Slips.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__